import { Component, inject, OnInit } from '@angular/core';
import { TermsOfUseComponent } from '../../components/terms-of-use/terms-of-use.component';
import { ROUTE_TERMS_OF_USE } from '../../app.constants';
import { HeaderLogoComponent } from '@shared-ikp/layout/header/header-logo/header-logo.component';
import { Router, RouterLink } from '@angular/router';
import { FooterComponent } from '../../layout/footer/footer.component';
import { homeRoutePrefix } from '@shared-ikp/app.constants';
import Keycloak from 'keycloak-js';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';

@Component({
  selector: 'ikp-terms-of-use-page',
  standalone: true,
  imports: [TermsOfUseComponent, HeaderLogoComponent, FooterComponent, RouterLink],
  templateUrl: './terms-of-use-page.component.html',
  styleUrl: './terms-of-use-page.component.scss',
})
export class TermsOfUsePageComponent implements OnInit {
  popupService = inject(IkpPopupService);
  protected keycloak = inject(Keycloak);
  protected router = inject(Router);
  isCollapsed = true;
  isLoggedIn = false;

  async ngOnInit() {
    if (this.keycloak.authenticated) {
      this.router.navigate([homeRoutePrefix(ROUTE_TERMS_OF_USE)]);
    }
  }
}
